;(function(){

    let $video;
    let startTime;

    // ヘッダーを最初だけダークモードに
    let header = document.querySelector('.l-header__in');// ヘッダー
    header.classList.remove('l-header--light');
    header.classList.add('l-header--dark');

    main();

    function main() {
        // document.body.addEventListener('pageshow', onPageShow);
        onPageShow();
    }

    /**
     * ページ表示
     */
    function onPageShow() {
        // ファーストビューロック
        new ScrollLock();

        // ローディング
        new Loading();

        // オープニング
        // テキスト分割
        document.querySelectorAll('[data-j-split="target"]').forEach(( dom )=>{
            new SplitText( dom );
        });
        document.querySelectorAll('[data-j-split-guide="target"]').forEach(( dom )=>{
            new SplitGuideText( dom );
        });
        // 動的テキストサイズ
        document.querySelectorAll('[data-j-dynamic-fontsize="target"]').forEach(( dom )=>{
            new DynamicFontSize( dom );
        });
        // オープニング本体
        document.querySelectorAll('[data-j-op="target"]').forEach(( dom )=>{
            new Opening( dom );
        });
        // 背景動画
        document.querySelectorAll('.p-home-bg').forEach(( dom )=>{
            new HomeBg( dom );
        });

        // スクロールコンテンツ
        document.querySelectorAll('[data-j-scroll-content="container"]').forEach(( dom )=>{
            new ScrollContents( dom );
        });

        // スキップ
        document.querySelectorAll('[data-j-skip-feature="switch"]').forEach(( dom )=>{
            new SkipFeature( dom );
        });
    }

    /**
     * ファーストビューロック
     */
    function ScrollLock() {
        let $html = document.documentElement;
        let $body = document.body;

        _init();

        function _init() {
            window.scrollTo(0,0);
            $body.scrollTo(0,0);
            $body.classList.add('is-scroll-lock');
            $body.addEventListener('opComplete', _onOpComplete);
        }

        function _onOpComplete() {
            $body.classList.remove('is-scroll-lock');
        }
    }

    /**
     * ローディング
     */
    function Loading() {
        //let $html = document.documentElement;
        let $body = document.body;
        let $loading = document.querySelector('[data-j-loading="target"]');
        $video =   document.querySelector('[data-j-loading="video"]');

        _init();

        function _init() {
            // トップ位置へスクロール
            window.scroll({
                top: 0,
                behavior: "instant",
            });

            startTime = performance.now();// 処理開始時間を記録

            // 動画読み込みで処理開始
            $video.addEventListener('loadeddata', ()=>{
                //console.log('video loadeddata');
                // 処理開始からの経過時間
                const elapsedTime = performance.now() - startTime;
                //console.log('経過時間', elapsedTime);
                if ( elapsedTime > 2000 ) {
                    // 処理開始から２秒経過していたらすぐに次処理へ
                    _init2();
                } else {
                    // 少し待ってからローディング画面を消して動画再生開始
                    setTimeout(_init2, (2000 - elapsedTime));
                }
            });

            function _init2() {
                // ローディング画像を非表示
                $loading.classList.add('is-hidden');
                // 動画再生
                $video.play();
                // 旧HOME動画スクロールコンテンツのfunc開始
                setTimeout(_complete, 500);
            }

            // 動画が再生されない場合の処理
            setTimeout(function(){
                //console.log('背景動画再生状況：停止→', $video.paused);
                if ($video.paused) {
                    console.log('動画を再ロード')
                    $video.load();
                }
            }, 5000);
        }

        /*
        function _onLoad() {
            //console.log('Loading: _onLoad');
            //clearTimeout( timer );
            $video.removeEventListener('playing', _onLoad);

            setTimeout(_showLogo, 1000);
        }

        function _showLogo() {
            //console.log('Loading: _showLogo');
            //$loading.classList.add('is-logo-visible');
            setTimeout(_hide, 2500);
        }

        function _hide() {
            //console.log('Loading: _hide');
            //$html.classList.add('is-home-waiting');
            //window.scrollTo(0,0);
            //$body.scrollTo(0,0);
            //$loading.classList.add('is-hidden');
            setTimeout(_complete, 1000);
        }
        */

        function _complete() {
            //console.log('_completed', '経過時間', performance.now() - startTime);
            //$html.classList.remove('is-home-waiting');
            $body.dispatchEvent(new Event('loadingComplete'));
        }
    }

    // GSAPアニメーション初期化
    function gsapInit() {
        // 動画の非表示・再表示、ヘッダー色調整
        gsap.to(
            '.concept2025-bg',
            {
                opacity: 0,
                scrollTrigger: {
                    trigger: '.concept2025-feature',
                    start: 'bottom 70%',
                    end:   'bottom 20%',
                    scrub: 1,
                    //markers: true,
                    onEnterBack:()=>{
                        //console.log('onEnterBack');
                        $video.play();
                        // ヘッダーの色調整
                        header.classList.remove('l-header--light');
                        header.classList.add('l-header--dark');
                    },
                    onLeave:()=>{
                        //console.log('onLeave');
                        $video.pause();
                        // ヘッダーの色調整を解除
                        header.classList.remove('l-header--dark');
                        header.classList.add('l-header--light');
                        header.style.backgroundColor = '#fff';
                    },
                }
            }
        );

        // コンセプト本文セクションの疑似遅延スクロール
        let conceptContent = document.querySelector('.p-concept');
        conceptContent.querySelector('.p-concept-content').style.paddingBottom = 0;// y値で疑似遅延スクロールさせるので下余白は解除しておきます
        gsap.fromTo(
            conceptContent,
            {
                y: 200,
            },
            {
                y: -200,
                //ease: "none",
                ease: "power2.out",
                scrollTrigger: {
                    trigger: conceptContent,
                    start: 'top bottom',
                    end:   'bottom top',
                    scrub: 1.5
                }
            }
        );

        /*
        // コンセプト本文画像のパララックス
        var conceptImages = gsap.utils.toArray('.p-concept img');
        conceptImages.forEach((image)=>{
            gsap.set(image, {scale:1.1});
            gsap.fromTo(
                image,
                {
                    y: '3%',
                },
                {
                    y: '-3%',
                    scrollTrigger: {
                        trigger: image,
                        start: 'top bottom',
                        end:   'bottom top',
                        scrub: 1.5
                    }
                }
            );
        });
        */

        //
        ScrollTrigger.refresh();
    }

    /**
     * テキスト分割
     */
    function SplitText( dom ) {
        let $target = dom;
        let original = $target.innerHTML;
        let lines = original.split('<br>');

        lines.forEach(( line, idx )=>{
            let newLine = '';
            line = line.trim();

            line.split('').forEach((char)=>{
                if ( char == ' ' ) {
                    newLine += '<span>&nbsp;</span>';
                }
                else if ( ['。', '、', 'ー'].indexOf( char ) >= 0 ) {
                    newLine += '<span><span class="ios-mark">' + char + '</span></span>';
                }
                else {
                    newLine += '<span>' + char + '</span>';
                }
            });
            lines[idx] = newLine;
        });

        $target.innerHTML = lines.join('<br>');
    }

    /**
     * テキスト分割(シャドウあり)
     */
    function SplitGuideText( dom ) {
        let $target = dom;
        let $shadow = document.createElement('span');
        let $base = document.createElement('span');
        let original = $target.innerHTML;
        let lines = original.split('<br>');

        lines.forEach(( line, idx )=>{
            // lines[idx] = '<span>' + line.trim() + '</span>';
            lines[idx] = '<span>' + line + '</span>';
        });

        $shadow.classList.add('guide-shadow');
        $shadow.innerHTML = lines.join('<br>');
        $base.classList.add('guide-base');
        $base.innerHTML = lines.join('<br>');

        $target.innerHTML = '';
        $target.appendChild( $shadow );
        $target.appendChild( $base );
    }

    /**
     * 動的テキストサイズ
     */
    function DynamicFontSize( dom ) {
        let $target = dom;
        let baseWidth = parseFloat( $target.getAttribute('data-j-dynamic-fontsize-width') );
        let baseHeight = parseFloat( $target.getAttribute('data-j-dynamic-fontsize-height') );
        let baseSpWidth = parseFloat( $target.getAttribute('data-j-dynamic-fontsize-sp-width') );
        let baseSpHeight = parseFloat( $target.getAttribute('data-j-dynamic-fontsize-sp-height') );
        _init();

        function _init() {
            _resize();

            window.addEventListener('resize', _onResize);
            window.addEventListener('orientationchange', _onResize);
        }

        function _onResize() {
            if ( typeof window.ontouchstart === 'undfined' ) {
                _resize();
            }
        }

        function _resize() {
            let mediaQuery = window.matchMedia('(min-width: 990px)');
            let targetWidth = $target.offsetWidth;
            let targetHeight = $target.offsetHeight;
            let resizeWidth = ( mediaQuery.matches ) ? baseWidth : baseSpWidth;
            let resizeHeight = ( mediaQuery.matches ) ? baseHeight : baseSpHeight;
            let scale = targetWidth / resizeWidth;

            if ( targetHeight < resizeHeight * scale ) {
                scale = targetHeight / resizeHeight;
            }

            $target.style.fontSize = ( scale * 10 ) + 'px';
        }
    }

    /**
     * オープニング
     */
    function Opening( dom ) {
        let $body = document.body;
        let $op = dom;

        _init();

        function _init() {
            $body.addEventListener('loadingComplete', _onLoadingComplete);
        }

        function _onLoadingComplete() {
            console.log( 'OP loadingComplete' );
            $op.classList.add('is-visible');

            setTimeout( _complete, 3000 );
        }

        function _complete() {
            $body.dispatchEvent( new Event('opComplete') );
        }
    }

    /**
     * 背景動画
     */
    function HomeBg( dom ) {
        let $body = document.body;
        let $base = dom;
        let $video = $base.querySelector('video');

        _init();

        function _init() {
            if ( ! $video ) {
                return;
            }
            $body.addEventListener('opComplete', _onOpComplete);
        }

        function _onOpComplete() {
            $video.currentTime = 0;
        }
    }

    /**
     * スクロールコンテンツ
     */
    function ScrollContents( dom ) {
        let $container = dom;
        let $sections = $container.querySelectorAll('[data-j-scroll-content="section"]');

        _init();

        function _init() {
            $sections.forEach(( dom )=>{
                let $section = dom;
                $section.style.position = 'fixed';
                $section.style.left = 0;
                $section.style.top = 0;
            });

            _resize();
            _update();
            window.addEventListener('resize', _onResize);
        }

        function _onResize() {
            if ( typeof window.ontouchstart === 'undfined' ) {
                _resize();
            }
        }

        function _resize() {
            let baseHeight = window.innerHeight
            let height = baseHeight;

            $sections.forEach(( dom )=>{
                let $section = dom;
                let range = parseFloat( $section.getAttribute('data-j-scroll-range') );
                height += baseHeight * range;
            });

            $container.style.height = height + 'px';

            //
            gsapInit();
        }

        function _update() {
            let top = $container.offsetTop;
            let baseHeight = window.innerHeight;
            let scroll = window.scrollY;
            let start = top;

            let $header = document.querySelector('#shopify-section-header');
            if ( $header ) {
                //start -= $header.offsetHeight;
                start -= parseInt(document.querySelector('#MainContent').style.paddingTop, 10);
            }

            $sections.forEach(( dom )=>{
                let $section = dom;
                let range = parseFloat( $section.getAttribute('data-j-scroll-range') );
                let height = baseHeight * range;
                let over = scroll - start;
                let overPer = Math.floor( 100 * over / height );
                overPer = ( overPer >= 0 ) ? overPer : -1;
                overPer = ( overPer <= 100 ) ? overPer : 100;

                $section.setAttribute( 'data-j-scroll-content-pos', overPer );

                start += height;
            });

            window.requestAnimationFrame( _update );
        }
    }

    // スキップ
    function SkipFeature( dom ) {
        let $btn = dom;
        /*
        let $target = document.querySelector('[data-j-skip-feature="target"]');
        let $header = document.querySelector('.j-header');
        */
        let $target = document.querySelector('.p-concept');
        let targetPosY = $target.getBoundingClientRect().top - window.innerHeight * 0.3;

        _init();

        function _init() {
            $btn.addEventListener('click', _onClickBtn);
        }

        function _onClickBtn(evt) {
            evt.preventDefault();
            /*
            let rect = $target.getBoundingClientRect();
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            let offsetTop = rect.top + scrollTop;
            let headerHeight = $header.offsetHeight + $header.offsetTop;

            window.scrollTo( 0, offsetTop - headerHeight );
            */
            window.scroll({
                top: targetPosY,
                behavior: "smooth",
            });
        }
    }

})();